import { Modal } from "antd";
import MultiFill from "container/testTemp/allTestTemp/tMultiFill/multiFill";
import MultiTap from "container/testTemp/allTestTemp/tMultiTap/multiTap.jsx";
import GetTest from "container/testTemp/getTestTemp/getTestTemp.jsx";
// import GetTest from "container/testTemp";

import React, { useState, useMemo, useEffect } from "react";
import { HelperContext } from "store/helperStore.jsx";
import ListenSpeak from "../../container/testTemp/allTestTemp/tListenSpeak/listenSpeak";
import "./testTempModal.scss";
import { Button, Input } from "reactstrap";
import { Modal as ReactstrapModal } from "reactstrap";
import { useDispatch } from "react-redux";
import { submitCommentFlagNotes, flagQuestion } from "action/actions";

const testTemp = [
  {
    testFormat: "listen_speak",
    myComp: ListenSpeak,
  },
  {
    testFormat: "listen_speak_sound",
    myComp: ListenSpeak,
  },
  {
    testFormat: "listen_speak_para",
    myComp: ListenSpeak,
  },
  {
    testFormat: "listen_speak_series",
    myComp: ListenSpeak,
  },
  {
    testFormat: "listen_speak_soundlist",
    myComp: ListenSpeak,
  },
  {
    testFormat: "listen_sound_differ",
    myComp: ListenSpeak,
  },
  // {
  //   testFormat: "listen_speak_soundlist",
  //   myComp: ListenSpeak,
  // },
  {
    testFormat: "multi_tap",
    myComp: MultiTap,
  },
  {
    testFormat: "single_tap_two",
    myComp: MultiTap,
  },
  {
    testFormat: "single_tap",
    myComp: MultiTap,
  },
  {
    testFormat: "visual_keypad",
    myComp: MultiTap,
  },
  {
    testFormat: "multi_fill",
    myComp: MultiFill,
  },
  {
    testFormat: "text_match_scroll",
    myComp: MultiTap,
  },
];

export const TestTempModal = ({ testTempData }) => {
  console.log("testTempData", testTempData);

  const { testData, testIndex, what } = testTempData;
  const { helperC, dispatchHelper } = HelperContext();
  const [state, setState] = useState({
    showViewModal: false,
    comment: "",
    submitBtn: false,
  });

  const dispatch = useDispatch();

  const handleTestTempCancel = () => {
    dispatchHelper({ type: "SET_TEST_TEMP_MODAL", payload: false });
  };

  const [match576, setMatch576] = useState(false);
  const matchMedia = useMemo(() => window.matchMedia("(max-width:575.98px)"));

  const handleMedia = function (e) {
    if (matchMedia.matches) {
      setMatch576(true);
    } else {
      setMatch576(false);
    }
  };

  useEffect(() => {
    handleMedia(matchMedia);
  }, []);

  useEffect(() => {
    matchMedia.onchange = handleMedia;

    return () => {
      matchMedia.onchange = null;
    };
  });

  const toggleModal = () => {
    setState({
      ...state,
      showViewModal: !state.showViewModal,
    });
  };

  const handeleCommetChange = (e) => {
    setState({
      ...state,
      comment: e.target.value,
      submitBtn: false,
    });
  };

  const handleSubmit = () => {
    if (state.comment.length !== 0) {
      setState({
        ...state,
        submitBtn: false,
      });
      let myData = {
        data: {
          player_id: testTempData.id,
          grade_id: testTempData.gradeId,
          test_id: testTempData.test_id,
          assessor_id: testTempData.assessor_id,
          comment: state.comment,
          que_id: testTempData.que_id,
        },
      };
      dispatch(flagQuestion(myData));
      // dispatch(submitCommentFlagNotes(myData));
      // props.submitCommentFlagNotes(myData);
      toggleModal();
    } else {
      setState({
        ...state,
        submitBtn: true,
      });
    }
  };

  return (
    <>
      <ReactstrapModal
        className="modal-dialog-centered"
        isOpen={state.showViewModal}
        toggle={toggleModal}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-default">
            Add comments
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleModal()}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <Input
            onChange={(e) => handeleCommetChange(e)}
            className="form-control-alternative"
            placeholder="Max. 500 char limit"
            type="textarea"
            maxlength="500"
            rows="5"
          />
        </div>
        <div className="modal-footer">
          <Button color="danger" onClick={toggleModal} type="button">
            Cancel
          </Button>
          <Button
            disabled={state.submitBtn}
            color="primary"
            onClick={handleSubmit}
            type="button"
          >
            Submit
          </Button>
        </div>
      </ReactstrapModal>

      <Modal
        width={match576 ? "90%" : "60%"}
        title={
          <div>
            <div className="flag-question">
              <Button
                className="px-1 py-1"
                style={{}}
                onClick={() => toggleModal()}
              >
                <div className="d-flex">
                  <div
                    className="mr-1 font-weight-bold"
                    style={{ fontSize: "13px" }}
                  >
                    Flag Question
                  </div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="currentColor"
                      className="bi bi-flag-fill"
                      viewBox="0 0 16 16"
                      style={{
                        color: "#9d1010",
                        marginBottom: "4px",
                      }}
                    >
                      <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001" />
                    </svg>
                  </div>
                </div>
              </Button>
            </div>
            <div style={{ textAlign: "center" }}>
              Question No. {testIndex + 1}
            </div>
          </div>
        }
        visible={helperC.testTempModal}
        onCancel={() => {
          handleTestTempCancel();
        }}
        footer={null}
        className="test-temp-modal"
        centered
      >
        {testTemp.map(({ testFormat, myComp }) => {
          console.log("testFormat", testFormat);
          return (
            <GetTest
              what={what}
              questions={testData}
              actualTestFormat={testData && testData.test_format}
              testFormat={testFormat}
              Component={myComp}
            ></GetTest>
          );
        })}
      </Modal>
    </>
  );
};
